<div class="app-component" style="height:100%">
  <div class="content" [ngClass]="{'small-header':smallHeader}">

    <router-outlet></router-outlet>

  </div>
</div>

